import { configure, bootstrapApp } from './main'

configure()
bootstrapApp('root')
